import { Plus } from "lucide-react";

import React from "react";

function CreateMode() {
  return (
    <div
      className="flex items-center justify-between 
                rounded-xl 
                border border-green-300 
                bg-green-50 
                px-4 py-3 
                shadow-sm"
    >
      {/* Left Section */}
      <div className="flex items-center gap-3">
        <div
          className="flex items-center justify-center 
                    w-9 h-9 
                    rounded-full 
                    bg-green-100 
                    text-green-600"
        >
          <Plus className="w-4 h-4" />
        </div>

        <div>
          <p className="text-sm font-semibold text-green-800">
            Create new permissions
          </p>
          <p className="text-xs text-green-600">
            You are creating fresh permission settings.
          </p>
        </div>
      </div>

      {/* Mode Badge */}
      <span
        className="text-xs font-medium 
                   px-3 py-1 
                   rounded-full 
                   bg-green-500 
                   text-white 
                   shadow-sm"
      >
        Create Mode
      </span>
    </div>
  );
}

export default CreateMode;
